// extracted by mini-css-extract-plugin
var _1 = "Ov5_gg8mqB";
var _2 = "zbUPrIBH43";
var _3 = "hO4gxHACy1";
var _4 = "iixeKSmGoA";
export { _1 as "body", _2 as "footer", _3 as "header", _4 as "main" }
